import { MAX_CAMPAIGN_NAME_LENGTH, MAX_TAGS } from './campaigns'
import { MINIMUM_PASSWORD_LENGTH } from './password'

export default {
  AI_CHAT_CREATE_CONVERSATION_ERROR: 'Failed to create conversation',
  AI_CHAT_DELETE_CONVERSATION_ERROR: 'Failed to delete conversation',
  AI_CHAT_DELETE_CONVERSATION_SUCCESS: 'Conversation deleted successfully',
  AI_CHAT_INSUFFICIENT_CREDITS: 'Insufficient credits to send message',
  AI_CHAT_SEND_MESSAGE_ERROR: 'Failed to send message',
  CAMPAIGN_ERROR_NAME_TOO_LONG: `Campaign name should not be more than ${MAX_CAMPAIGN_NAME_LENGTH} characters`,
  CHANGE_CONVERSION_STATUS_ERROR_MESSAGE: 'Failed to update conversion status',
  CHANGE_CONVERSION_STATUS_SUCCESS_MESSAGE: 'Conversion status updated',
  CHANGE_SENTIMENT_TYPE_ERROR_MESSAGE: 'Failed to change sentiment type',
  CHANGE_SENTIMENT_TYPE_SUCCESS_MESSAGE: 'Sentiment type changed successfully',
  COMPLETE_CAMPAIGN_SUCCESS_MESSAGE: 'Campaign completed successfully',
  CONTENT_ANALYSIS_CREATE_ERROR: 'Failed to create content analysis',
  CONTENT_ANALYSIS_CREATE_SUCCESS: 'Content analysis created successfully',
  CONTENT_ANALYSIS_DELETE_ERROR: 'Failed to delete content analysis',
  CONTENT_ANALYSIS_DELETE_SUCCESS: 'Content analysis deleted successfully',
  CONTENT_ANALYSIS_DRAFT_SUCCESS: 'Content analysis saved as draft',
  CONTENT_ANALYSIS_UPDATE_ERROR: 'Failed to update content analysis',
  CONTENT_ANALYSIS_UPDATE_SUCCESS: 'Content analysis updated successfully',
  CREATE_CAMPAIGN_ERROR_MESSAGE: 'Failed to create campaign',
  CREATE_CAMPAIGN_SUCCESS_MESSAGE: 'Campaign created successfully',
  EMAIL_EXAMPLE: 'mail@website.com',
  EMPTY_TARGETS_ERROR: 'Target source is not identified',
  ERROR_CSV: 'Error downloading CSV',
  FACEBOOK_LOGIN_ERROR_MESSAGE: 'Failed to login with Meta',
  FACEBOOK_LOGOUT_ERROR_MESSAGE: 'Failed to logout from Meta',
  HEADER_DATEPICKER_TOOLTIP:
    'The date range you select will be applied to all reports.',
  INVALID_CREDENTIALS: 'Invalid credentials',
  IRRELEVANT_KEYWORD_ERROR_CONFLICTS_WITH_KEYWORD:
    'Cannot add as irrelevant keyword - already exists as a regular keyword',
  IRRELEVANT_KEYWORD_ERROR_DUPLICATE:
    'This irrelevant keyword is already added',
  IRRELEVANT_KEYWORD_ERROR_EMPTY: 'Cannot be empty',
  IRRELEVANT_KEYWORD_ERROR_TOO_LONG:
    'Irrelevant keyword cannot exceed 50 characters',
  IRRELEVANT_KEYWORD_ERROR_TOO_MANY: 'Maximum 50 irrelevant keywords allowed',
  IRRELEVANT_KEYWORD_SUCCESS_ADDED: 'Irrelevant keyword added successfully',
  KEYWORD_ERROR_EMPTY: 'Cannot be empty',
  KEYWORD_ERROR_NOT_SAME_TAG: 'Keyword can not be the same as tag',
  KEYWORD_ERROR_OVER_10_WORDS: 'Tag should not exceed 10 words',
  MIN_CHARACTERS_PASSWORD: `Min. ${MINIMUM_PASSWORD_LENGTH} characters`,
  PASSWORD_ERROR_NOT_FILLED_ALL_FIELDS:
    'Fill all password fields to update password',
  PASSWORD_ERROR_NOT_MATCHING: "New passwords don't match",
  PASSWORD_ERROR_TOO_SHORT: `New password must be at least ${MINIMUM_PASSWORD_LENGTH} characters long`,
  SAVE_CAMPAIGN_AS_DRAFT_SUCCESS_MESSAGE:
    'Campaign saved as draft successfully',
  SENTIMENT_ERROR_ALREADY_IN_USE: 'Sentiment you entered is already in use',
  SENTIMENT_ERROR_ALREADY_USED_AS_NEGATIVE:
    'Sentiment you entered is already used as negative sentiment',
  SENTIMENT_ERROR_ALREADY_USED_AS_POSITIVE:
    'Sentiment you entered is already used as positive sentiment',
  SENTIMENT_ERROR_NOTHING_TO_PASTE: 'Nothing to paste',
  SENTIMENT_ERROR_NO_UNIQUE_SENTIMENTS_PASTED:
    'No unique sentiments were detected',
  SENTIMENT_ERROR_OVER_20_WORDS:
    'Sentiments identified in keyword should not be more than 20 words',
  SENTIMENT_ERROR_PASTE_NEGATIVE: 'Cant paste negative sentiment(s): ',
  SENTIMENT_ERROR_PASTE_POSITIVE: 'Cant paste positive sentiment(s): ',
  SENTIMENT_ERROR_TOO_MANY_WORDS: 'Sentiment should not exceed 3 words',
  SENTIMENT_ERROR_USED_AS_KEYWORD: 'Sentiment you entered is used as keyword',
  SENTIMENT_ERROR_USED_WRONG_CHARACTERS:
    'You cannot use characters in sentiments except " - "',
  SENTIMENT_SUCCESS_PASTED: 'Sentiments were pasted successfully',
  TAG_ERROR_ALREADY_IN_USE: 'Tag you entered is already in use',
  TAG_ERROR_ALREADY_USED_AS_KEYWORD: 'Tag you entered is used as keyword',
  TAG_ERROR_ALREADY_USED_AS_KEYWORD_CATEGORY:
    'Tag you entered is keyword category',
  TAG_ERROR_ALREADY_USED_AS_NEGATIVE_SENTIMENT:
    'Tag you entered is already used as negative sentiment',
  TAG_ERROR_ALREADY_USED_AS_POSITIVE_SENTIMENT:
    'Tag you entered is already used as positive sentiment',
  TAG_ERROR_LIMIT: `Tags identified in campaign should not be more than ${MAX_TAGS}`,
  TAG_ERROR_TOO_MANY_WORDS: 'Tag should not exceed 3 words',
  TAG_SUCCESS_ADDED: 'Tag added successfully',
  UPDATE_CAMPAIGN_SUCCESS_MESSAGE: 'Campaign updated successfully',
  USER_PASSWORD_UPDATE_ERROR_MESSAGE: 'Failed to update password',
  USER_PASSWORD_UPDATE_SUCCESS_MESSAGE: 'Password updated successfully',
  USER_UPDATE_ERROR_MESSAGE: 'Failed to update user',
  USER_UPDATE_SUCCESS_MESSAGE: 'User updated successfully',
  WORD_IS_ALREADY_IN_USE: 'Word is already in use',
  add: 'Create',
  addIrrelevantKeyword: 'Add Irrelevant Keyword',
  addNewCampaign: 'Add new Campaign',
  addNewCategory: 'Add new Category',
  addNewKeyword: 'Add new Keyword',
  all: 'All',
  allCampaigns: 'All Campaigns',
  allFacilities: 'All Facilities',
  allSources: 'All Sources',
  allTopics: 'All Topics',
  areYouSure: 'Are you sure',
  areYouSureYouWantToDelete: 'Are you sure you want to delete',
  back: 'Back',
  backToTop: 'Back to Top',
  calendar: 'Calendar',
  calendarDetails: 'Calendar Details',
  campaign: 'Campaign',
  campaignName: 'Campaign Name',
  campaigns: 'Campaigns',
  cancel: 'Cancel',
  categories: 'Categories',
  category: 'Category',
  categoryName: 'Category name',
  changeConversionStatus: 'Mark conversion',
  changeSentiment: 'Change Sentiment',
  chooseCampaign: 'Choose Campaign',
  comment: 'Comment',
  company: 'Company',
  companyName: 'Company name',
  comparisons: 'Comparisons',
  complete: 'Complete',
  confirm: 'Confirm',
  confirmPassword: 'Confirm password',
  connect: 'Connect',
  countries: 'Countries',
  country: 'Country',
  create: 'Create',
  createAccount: 'Create Account',
  createNewCampaign: 'Create New Campaign',
  createNewKeyword: 'Create New Keyword',
  createdAt: 'Created at',
  custom: 'Custom',
  dailyNegativeMentions: 'Daily Negative Mentions',
  dailyPositiveCampaign: 'Top Positive Campaign',
  dailyPositiveMentions: 'Daily Positive Mentions',
  dailyTrends: 'Daily Trends',
  delete: 'Delete',
  deselectAll: 'Deselect all',
  disconnect: 'Disconnect',
  downloadCsvReport: 'Download Report',
  downloadMentionsReport: 'Download Mentions Report',
  downloading: 'Downloading...',
  downoadCSV: 'Download CSV',
  duplicateCampaign: 'Duplicate',
  edit: 'Edit',
  editCampaign: 'Edit Campaign',
  email: 'Email',
  enterAKeyword: 'Enter a Keyword',
  enterIrrelevantKeyword: 'Enter keyword to exclude...',
  enterNameOfCampaign: 'Enter name of campaign',
  enterTagsToFilter: 'Enter tags to filter',
  evaluation: 'Evaluation',
  facebook: 'Facebook',
  facebookTargetEndpoints: 'Facebook target page addresses',
  facilities: 'Facilities',
  filter: 'Filter',
  filters: 'Filters',
  firstName: 'First name',
  forgotPassword: 'Forgot password?',
  format: 'Format',
  gender: 'Gender',
  haveAccount: 'Already have an account?',
  hotLinks: 'Hot Links',
  instagramTargetEndpoints: 'Instagram target page names',
  irrelevantKeywords: 'Irrelevant Keywords',
  irrelevantKeywordsTooltip:
    'These keywords will be excluded from your campaign monitoring results. Any content containing these words will be filtered out.',
  keyWordsAdded: 'Keywords added',
  keyword: 'Target Keywords',
  keywordAnalyses: 'Keyword Analysis',
  keywords: 'Keywords',
  languages: 'Languages',
  last30Days: 'Last 30 days',
  last7Days: 'Last 7 days',
  last90Days: 'Last 90 days',
  lastName: 'Last name',
  less: 'Less',
  lifetime: 'Lifetime',
  liveNotifications: 'Live Notifications',
  loading: 'Loading ...',
  locationChart: 'Location Chart',
  locationChartAdditionalText:
    'Location Chart collects data that should be incomplete.',
  locationChartUsingList: 'Location Chart using List',
  locationChartUsingMap: 'Location Chart using Map',
  logOut: 'Log out',
  login: 'Log in',
  mentionFormat: 'Mention Format',
  mentions: 'Mentions',
  mentionsByMonth: 'Mentions by Month',
  meta: 'Meta',
  min8Characters: 'Min. 8 characters',
  more: 'More',
  mostMentions: 'Most Mentions',
  mostMentionsAmount: 'Most Mentions Amount',
  mostlyNegative: 'Mostly Negative',
  mostlyNeutral: 'Mostly Neutral',
  mostlyPositive: 'Mostly Positive',
  mostlyRatedAs: 'Mostly Rated As',
  name: 'Name',
  negative: 'Negative',
  negativeMentions: 'Negative mentions',
  negativeSentiments: 'Negative sentiments',
  negatives: 'Negatives',
  neutral: 'Neutral',
  neutralMentions: 'Neutral mentions',
  neutrals: 'Neutrals',
  newPassword: 'New password',
  next: 'Next',
  noCalendarData: 'No calendar data available',
  noCalendarDataDescription:
    'There is no campaign activity data to display for this period',
  noCalendarDetailsData: 'No data available for this date',
  noCalendarDetailsDescription:
    'Select a date with campaign activity to view details',
  noCampaignsFound: 'No campaigns found',
  noDataToDisplay: 'There is no data to display',
  noKeywordsFound: 'No keywords found',
  noPostsAvailable: 'No posts available',
  noReviewText: 'No review text — rating only',
  notEnoughDataToDisplay: 'There is not enough data to display',
  nothingHereYet: 'Nothing here yet',
  number: 'Number',
  ofTotalMentions: 'Of Total Mentions',
  oldPassword: 'Old password',
  orderBy: 'Order By',
  others: 'Others',
  overview: 'Overview',
  password: 'Password',
  platform: 'Platform',
  platformSelected: 'Platform Selected',
  positive: 'Positive',
  positiveMentions: 'Positive mentions',
  positiveSentiments: 'Positive sentiments',
  positives: 'Positives',
  positivityChart: 'Positivity Chart',
  previous: 'Previous',
  quickDetails: 'Quick Details',
  radarChart: 'Radar chart',
  region: 'Region',
  relevancy: 'Relevancy',
  relevancyTitleTooltip:
    'Using more general keywords will help you catch more sentiments.',
  rememberMe: 'Remember me',
  remove: 'Remove',
  removeKeyword: 'Remove Keyword',
  rename: 'Rename',
  resetFilter: 'Reset Filter',
  save: 'Save',
  saveAsDraft: 'Save to draft',
  saveAsTemplate: 'Save as template',
  search: 'Search',
  searchByTextOrUrl: 'Search by text or url',
  seeAll: 'See all',
  seeOriginal: 'See original',
  seeTranslation: 'See translation',
  selectAll: 'Select all',
  selectDeselectAllCampaigns: 'Select/Deselect All Campaigns',
  selected: 'Selected',
  selectedCampaign: 'Selected Campaign',
  selectedReviews: 'Selected reviews:',
  sentimentAnalyses: 'Sentiment Analysis',
  sentimentChart: 'Sentiment Chart',
  sentiments: 'Sentiments',
  settings: 'Settings',
  signInToAccessYourAccount: 'Sign in to access your account',
  signingIn: 'Signing in…',
  signup: 'Sign up',
  somethingWentWrong: 'Something went wrong',
  sources: 'Sources',
  suggested: 'Suggested',
  suggestedVariations: 'Suggested Variations',
  suggestions: 'Suggestions',
  tagTooltip: 'You cannot edit target sources',
  tags: 'Tags',
  tagsAdded: 'Tags added',
  target: 'Target',
  textIsTranslatedFrom: 'This text is translated from',
  than: 'Than',
  themeName: 'Campaign name',
  themesSelected: 'Themes selected',
  threads: 'Threads',
  timezone: 'Timezone',
  today: 'Today',
  topCampaigns: 'Top Campaigns',
  topKeywords: 'Top Keywords',
  topLocation: 'Top Location',
  topSource: 'Top Source',
  topSources: 'Top Sources',
  total: 'Total',
  totalMentions: 'Total mentions',
  unSelectAll: 'Unselect all',
  updateCampaign: 'Update Campaign',
  updatedAt: 'Updated at',
  variationsDoNotCount: 'Variations do not count toward your keyword limit.',
  worldwide: 'Worldwide',
  yesterday: 'Yesterday',
}
